import React, { useEffect, useRef } from 'react';
import { Animated, Platform } from 'react-native';

import type { UseSound } from '../../../../hooks/use-sound';
import type { TabActivityStepInterface } from '../../../../interfaces/tab-activity';
import KaraokeAudioPlayer from '../../karaoke-audio-player/karaoke-audio-player';

interface TabActivityCardDefinitionAudioProps {
  item: TabActivityStepInterface;
  cardWidth: number;
  active: boolean;
  sound: UseSound;
}

const TabActivityCardDefinitionAudio: React.FC<
  TabActivityCardDefinitionAudioProps
> = ({ item, cardWidth, active, sound }) => {
  const opacityAnimation = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.timing(opacityAnimation, {
      toValue: active ? 1 : 0,
      duration: 500,
      useNativeDriver: true,
    }).start();
  }, [active, opacityAnimation]);

  const showKaraokeAudio = Platform.OS === 'web' ? active : true;

  const styles = {
    definitionAudio:
      Platform.OS === 'web' ? { opacity: opacityAnimation } : { opacity: 1 },
  };

  return (
    <Animated.View style={[styles.definitionAudio, { width: cardWidth }]}>
      {showKaraokeAudio && (
        <KaraokeAudioPlayer text={item.definition} sound={sound} />
      )}
    </Animated.View>
  );
};

export default TabActivityCardDefinitionAudio;
